export default {
  email: null,
  firstName: null,
  lastName: null,
  organizationId: null,
};



// WEBPACK FOOTER //
// ./src/app/store/modules/account/state.js